import { InjectionToken } from '@angular/core';

export const DISK_PRELOAD_REQUEST_MAP = new InjectionToken<ReadonlyMap<string, Promise<Response>>>('DISK_PRELOAD_REQUEST_MAP');
